import React from 'react';
import NonMobileHeader from '../components/Headers/NonMobileHeader';

export default function Header({ usrName }) {
    return <NonMobileHeader usrName={usrName} />;
}
